import { ApiUrls } from "../types/enums";
import { DEFAULT_CULTURE, DEFAULT_TERMINAL } from "../shared/constants";

export const getAuthorizationMessages = async ({
  authorizationKeys,
  config,
}: GetAuthorizationMessagesPayload): Promise<GetAuthorizationMessagesResponse> => {
  const response = await fetch(ApiUrls.GET_AUTHORIZATION_MESSAGE, {
    method: "POST",
    headers: {
      brandid: config.brandId,
      channelid: config.channelId,
      terminal: config.terminal || DEFAULT_TERMINAL,
      language: config.language || DEFAULT_CULTURE,
      "content-type": "application/json",
      ...(config.userToken
        ? {
            token: config.userToken,
            authorization: `Bearer ${config.userToken}`,
          }
        : {}),
    },
    body: JSON.stringify({
      authorizationKeys,
    }),
  });

  return response.json();
};
